const STEPS = [
  { icon: "ri-question-line", title: "先看语境", desc: "名场面往往截取自完整现场。先补足「发生了什么、在哪发生」，再下判断。" },
  { icon: "ri-eye-line", title: "分辨信息", desc: "把「现场事实」与「网友演绎」分开看，热度高不等于结论稳。" },
  { icon: "ri-emotion-happy-line", title: "轻松参与", desc: "吃瓜的本质是分享快乐与共鸣，带着松弛感讨论，别让讨论变负担。" },
  { icon: "ri-leaf-line", title: "保持边界", desc: "娱乐归娱乐，尊重每一位真实的人。理性吃瓜，也让圈子更健康。" },
];

export default function Guide() {
  return (
    <section id="guide" className="relative overflow-hidden bg-primary-950 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-accent-300 uppercase">
            <i className="ri-compasses-2-line" aria-hidden="true"></i>
            Guide
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold text-background-50 md:text-4xl">理直气壮的吃瓜指南</h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            内容愈热闹，愈需要一份「清醒说明书」。我们把「吃透每一层」落到四个简单原则，让瓜吃得尽兴、也吃得体面。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <div
              key={s.title}
              className="flex flex-col rounded-2xl border border-background-100/10 bg-background-50/5 p-6 backdrop-blur transition-colors hover:border-accent-400/40"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-5xl font-black text-background-50/10">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-background-50">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}